<template>
  <span class="toggle" :class="{'toggle--disabled': disabled}">
    <span class="toggle__status"
      :class="toggleStatusClass"
      @click="onClickIcon"
      >
      <i
        class="fa"
        :class="{
          'fa-toggle-on'  : toggled,
          'fa-toggle-off' : !toggled,
        }"
        >
      </i>
    </span>
    <span class="toggle__label" :class="{'text-muted': disabled}" @click="onClickLabel">
      <slot></slot>
    </span>
  </span>
</template>

<script>
export default {
  name: 'toggle',
  props: {
    value: {
      type    : [Boolean, Number, String],
      default : false
    },
    disabled: {
      type    : Boolean,
      default : false
    },
    pToggleOnClickIcon: {
      type    : Boolean,
      default : true
    },
    pToggleOnClickLabel: {
      type    : Boolean,
      default : false
    },
    pClassWhenOff: {
      type: String,
      default: 'text-muted'
    },
    pClassWhenOn: {
      type: String,
      default: 'text-success'
    },
  },
  data() {
    return {
      toggled: this.value
    }
  },
  watch: {
    value(val) {
      this.toggled = val
    }
  },
  computed: {
    toggleStatusClass() {
      let value = {}

      value[this.pClassWhenOn] = this.toggled
      value[this.pClassWhenOff] = !this.toggled

      return value
    }
  },
  methods: {
    onClickIcon() {
      if (!this.pToggleOnClickIcon) {
        return
      }
      this.toggle()
    },
    onClickLabel() {
      if (!this.pToggleOnClickLabel) {
        return
      }
      this.toggle()
    },
    toggle() {
      if (this.disabled) {
        return
      }

      this.$emit('input', !this.toggled)
    }
  }
}
</script>
